import React, { ReactNode } from 'react';
import { ButtonV2Props } from '../../components/ButtonV2';


export const Cta = ({
  label,
  as: Component = 'a',
  className = '',
}: ButtonV2Props & { label: ReactNode }) => {
  return (
    <Component className={className}>
      {label ?? 'Découvrir nos offres.'}
    </Component>
  );
};
